import { Injectable, inject } from '@angular/core';
import { HttpService, UrlService } from '@boels/helpers';
import {
  CartUrlEnum,
  GeoPoint,
  PointOfServiceStock,
  SearchConfig,
  StoreFinderStockSearchPage,
} from '@boels/models';
import { filter, map, Observable, switchMap, withLatestFrom } from 'rxjs';
import { ApiContextService, CartManagementService } from '../../services';

@Injectable({
  providedIn: 'any',
})
export class ProductStockGatewayService {
  private readonly httpService = inject(HttpService);
  private urlService = inject(UrlService);
  private apiContextService = inject(ApiContextService);
  private cartManagementService = inject(CartManagementService);

  search(
    productCodes: string[],
    query: string,
    searchConfig: SearchConfig,
    longitudeLatitude?: GeoPoint,
  ): Observable<PointOfServiceStock[]> {
    return this.apiContextService.getContext().pipe(
      filter(([baseSite]) => !!baseSite),
      withLatestFrom(
        this.cartManagementService.getCartUser(),
        this.cartManagementService.getCartId(),
      ),
      switchMap(([[baseSite, language, currency], cartUser, cartId]) => {
        let params = [
          ['currentPage', String(searchConfig.currentPage)],
          ['pageSize', String(searchConfig.pageSize)],
        ];

        if (longitudeLatitude) {
          params = [
            ...params,
            ['longitude', String(longitudeLatitude.longitude)],
            ['latitude', String(longitudeLatitude.latitude)],
            ['lang', language],
            ['curr', currency],
          ];
        } else {
          params = [
            ...params,
            ['location', query],
            ['lang', language],
            ['curr', currency],
          ];
        }

        const url = this.urlService.combineUri(
          baseSite.uid,
          this.cartManagementService.getCartUrl(
            cartUser.type,
            CartUrlEnum.CARTS,
          ),
          cartId,
          productCodes[0],
          'stock',
        );

        const httpHeaders = this.cartManagementService.getHttpHeaders(cartUser);
        return this.httpService
          .get<StoreFinderStockSearchPage>(url, params, httpHeaders)
          .pipe(
            map(
              (storeFinderStockSearchPage) =>
                storeFinderStockSearchPage.stores as PointOfServiceStock[],
            ),
          );
      }),
    );
  }
}
